<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Dashboard</div>
		</div>

		<div class="pt-1 pb-5 mb-3 d-flex font-size-10 grey--text">
			<router-link to="/">
				<div class="d-flex">
					<v-icon small color="grey">mdi-home</v-icon>
					<div class="pl-2 grey--text">Dashboard</div>
				</div>
			</router-link>
		</div>

		<!-- new dashboard -->
		<template v-if="!loading">
			<div class="mt-5">
				<v-row>			
					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="6" md="6" class="align-stretch" v-if="Object.values(myProfile).length > 0">
							<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
								<v-row>
									<v-col cols="12" class="d-flex flex-row align-center justify-space-between">
										<div class="font-size-12 cl-grey font-weight-500">Profil</div>
										<v-btn
												color="primary"
												small
												text
												@click="goProfile"
											>
												Lihat Detail
											</v-btn>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" sm="12" md="4" class="d-flex flex-column flex-stretch text-center justify-start align-center">
										<v-img height="120" width="120" class="user-img mx-auto rounded-pill hover-shadow" style="max-height: 120px;" :src="(myProfile.member_image_url) ? myProfile.member_image_url : '/assets/image/profile-pict.png'"></v-img>
										<div class="bottom-shadow"></div>
									</v-col>

									<v-col cols="12" sm="12" md="8">
										<div class="mb-4 font-size-14 font-weight-600 cl-primary text-uppercase">{{ myProfile.member_name }}</div>
										<v-row class="mb-3">
											<v-col cols="12" sm="12" md="6" v-if="myProfile.network_code">
												<div class="font-size-10 cl-grey">Kode Mitra</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.network_code }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Tanggal Gabung</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_join_datetime | tanggal }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" v-if="!myProfile.network_code">&nbsp;</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Sponsor</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_sponsor_network_code ? myProfile.member_sponsor_network_code : '-' }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Upline</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.network_upline_network_code ? myProfile.network_upline_network_code : '-' }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Email</div>
												<div class="font-size-11 cl-grey font-weight-600" v-html="$options.filters.longText(myProfile.member_email, 20)"></div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Nomor HP</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_mobilephone ? myProfile.member_mobilephone : '-' }}</div>
											</v-col>
										</v-row>

										<template v-if="myProfile.network_type !== 'diamond' && isActiveMember">
											<v-row class="mb-1">
												<v-col cols="12" sm="12" class="pt-1">
														<v-btn
															color="primary"
															outlined
															block
															@click="gotoUpgrade"
														><v-icon dense class="mr-1">mdi-shield-account-outline</v-icon>Upgrade Kemitraan</v-btn>
												</v-col>
											</v-row>
										</template>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-scroll-x-transition>

					<template v-if="isActiveMember">
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="12" md="6" class="align-stretch" v-if="networkType">
								<v-card class="pa-5 elevation-0 rounded-lg hover-shadow mb-5 d-sm-block d-md-none d-xl-none">
									<div class="d-flex flex-column justify-start">
										<div class="d-flex flex-row align-center mb-3">
											<img class="img-fluid img-darken" src="/assets/icon/wallet.svg" width="24">
											<div class="font-size-12 gray--text darken-1 pl-3 font-weight-bold" style="line-height: normal;">Total Saldo Belanja</div>
										</div>

										<div class="font-size-18 cl-primary darken-5 font-weight-600">{{ ewalletSummary.ewallet_product_balance | toRupiah }}</div>
									</div>
								</v-card>

								<v-card class="pa-5 elevation-0 rounded-lg hover-shadow mb-5 d-none d-md-block">
									<div class="d-flex flex-row align-center justify-space-between">
										<div class="d-flex flex-row align-center">
											<img class="img-fluid img-darken" src="/assets/icon/wallet.svg" width="36">
											<div class="font-size-12 gray--text darken-1 pl-4 font-weight-bold" style="line-height: normal;">Total<span class="d-block">Saldo Belanja</span></div>
										</div>

										<div class="font-size-18 cl-primary darken-5 font-weight-600">{{ ewalletSummary.ewallet_product_balance | toRupiah }}</div>
									</div>
								</v-card>

								<v-card class="pa-8 elevation-0 rounded-lg hover-shadow mitra-card" :class="networkType.classText" style="height: calc(100% - 100px);">
									<template v-if="Object.values(myProfile).length > 0"><upgradedate-alert :myProfile="myProfile" :networkType="myProfile.network_type" style="margin-top: -25px;"></upgradedate-alert></template>
									<v-row justify="center" class="fill-height flex-stretch mt-0">
										<v-col cols="12" sm="12" md="4" class="pa-4 d-flex align-center justify-center">
											<v-img eager width="180" style="height: auto;max-width: 100%;" class="mx-auto" :src="networkType.badges"></v-img>
										</v-col>
										<v-col cols="12" sm="12" md="8">
											<div class="rank-text">
												<div class="font-size-14 font-weight-500 cl-darkgrey">Peringkat Kemitraan Anda Saat Ini</div>
												<h1 class="font-weight-bold text-uppercase my-3" :style="'color:' + networkType.color">
													{{ (networkType.type === 'gold') ? 'Gold Star' : (networkType.type === 'repeat_order') ? 'Silver' : networkType.type }}
												</h1>
												<template v-if="networkType">
													<div class="d-flex flex-column px-4 font-size-9">
														<div>Akumulasi Pembelanjaan Anda telah mencapai<span class="d-block font-size-16 font-weight-600" :style="'color:' + networkType.color">{{ networkType.belanja }}</span></div>
													</div>
												</template>
											</div>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
					</template>

					<template v-else>
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="4" md="6" class="align-stretch" v-if="networkType">
								<v-card class="pa-8 elevation-0 rounded-lg hover-shadow fill-height mitra-card" :class="networkType.classText">
									<v-row justify="center" class="fill-height flex-stretch mt-0">
										<v-col cols="12" sm="12" md="12">
											<div class="rank-text">
												<div class="font-size-14 font-weight-500 yellow--text">Selamat datang <b class="text-uppercase">{{ myProfile.member_name }}</b>,</div>
												<div class="font-size-14 font-weight-500 yellow--text mb-2">Selamat bergabung bersama MLM Esoftdream</div>

												<div class="font-size-10 font-weight-400 cl-white mb-5">Saat ini anda belum melakukan aktivasi akun, sehingga mungkin beberapa fitur belum dapat anda gunakan.</div>
												<div class="font-size-10 font-weight-600 cl-white mb-5">Segera lakukan aktivasi untuk dapat mengakses fitur-fitur utama kami, melakukan transaksi serta mendapatkan informasi seputar komisi yang anda dapatkan.</div>
												
												<v-btn depressed color="warning" dark large elevation="2" class="white--text rounded-lg text-uppercase font-weight-bold" @click="goActivation">
													<v-icon>mdi-account-reactivate-outline</v-icon>
													<span class="pl-2">Aktivasi Akun Saya</span>
												</v-btn>
											</div>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
					</template>
				</v-row>
			</div>

			<div class="my-5" v-if="serialCount">
				<v-row class="">
					<v-col cols="12" sm="6" md="3" class="flex-stretch d-flex" v-for="(serial, ids) in serialCount" :key="ids">
						<v-card class="pa-5 elevation-0 rounded-lg hover-shadow grey lighten-3">
							<v-row class="align-start">
								<v-col cols="2" sm="3" md="2" class="pr-0 my-auto text-right d-flex alilgn-start">
									<img class="img-fluid img-darken" src="/assets/icon/serial_registrasi.svg" style="width: 90%;">
								</v-col>
								<v-col cols="10" sm="9" md="10">
									<div class="font-size-18 green--text darken-3 font-weight-600">{{ serial.serial_type_count }}</div>
									<div class="font-size-11 black--text text-capitalize">Serial {{ (serial.serial_type_name === 'repeatorder') ? 'RO' : serial.serial_type_name }} Saya</div>
								</v-col>
							</v-row>

							<template v-if="serial.serial_type_has_child">
								<ul class="serial-list">
									<li v-for="(subSerial, idss) in serial.serial_type_child_detail" :key="idss">
										<div class="d-flex alilgn-center justify-space-between py-1 text-capitalize font-size-9">
											<span>{{ subSerial.serial_type_name.replace('_to_', ' ke ') }}</span>
											<span class="font-weight-600">{{ subSerial.serial_type_count }}</span>
										</div>
									</li>
								</ul>
							</template>
						</v-card>
					</v-col>
				</v-row>
			</div>

			<template v-if="isActiveMember">
				<v-row justify="center" class="mb-4">
					<v-col cols="12" sm="12" md="12" xl="12">
						<v-card class="elevation-0 rounded-lg pb-2">
							<v-card-title style="font-size: 18px!important;">
								<v-icon dense class="mr-2">mdi-wallet-giftcard</v-icon>Potensi Komisi Hari Ini
							</v-card-title>
							<div class="d-block px-5 pb-5">
								<div class="d-none d-md-flex flex-row align-center justify-center">
									<div class="d-flex flex-grow-1 flex-shrink-1" :class="(idk === 0) ? 'ml-0 mr-2' : (idk === (listBonusToday.length - 1) ? 'ml-2 mr-0' : 'mx-2')" :style="{ width: (100 / listBonusToday.length) + '%' }" v-for="(komisi, idk) in listBonusToday" :key="idk">
										<v-card outlined color="#E0F2F1" class="elevation-0 hover-shadow w-100">
											<v-card-subtitle class="d-flex flex-column black--text lighten-3 pb-1">
												<span class="font-weight-bold">{{ formatKomisiLabel(komisi.label) }}</span>
											</v-card-subtitle>
											<div class="d-block px-4 pb-4 font-size-14 green--text font-weight-600">{{ komisi.value | toRupiah }}</div>
										</v-card>
									</div>
								</div>
								
								<v-row justify="start" class="d-flex d-md-none">
									<v-col cols="12" sm="12" md="12" class="py-1" v-for="(komisi, idk) in listBonusToday" :key="idk">
										<v-card outlined color="#E0F2F1" class="elevation-0 hover-shadow">
											<v-card-subtitle class="black--text lighten-3 font-weight-bold pb-1">{{ komisi.label }}</v-card-subtitle>
											<div class="d-block px-4 pb-4 font-size-14 green--text font-weight-600">{{ komisi.value | toRupiah }}</div>
										</v-card>
									</v-col>
								</v-row>
							</div>
						</v-card>
					</v-col>
				</v-row>

				<div class="mt-5">
					<v-row>
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="6" md="6" class="flex-stretch">
								<v-row>
									<v-col cols="12" sm="12" md="6">
										<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height" style="height: 340px">
											<div class="font-size-12 cl-grey font-weight-500 text-center">Total Komisi Anda</div>
											<v-card-text class="px-0 d-flex flex-column justify-space-between fill-height">
												<div class="py-5">
													<v-img width="130" class="mx-auto my-5" style="height: auto; max-height: auto;" src="/assets/icon/coins.svg"></v-img>
												</div>
												<h2 class="d-block text-center py-5">{{ listSummaryBonus.totalAcc | toRupiah }}</h2>
											</v-card-text>
										</v-card>
									</v-col>

									<v-col cols="12" sm="12" md="6">
										<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
											<div class="font-size-12 cl-grey font-weight-500 text-center">Rincian Komisi</div>
											<div id="chart-rincian-komisi" class="fill-height py-4">
												<template v-if="listSummaryBonus.totalAcc === 0">
													<div class="empty-pie" style="width:135px; height: 135px;"></div>
												</template>
												<apexchart type="pie" :options="rincianKomisi.chartOptions" :series="rincianKomisi.series" height="280"></apexchart>
											</div>
										</v-card>
									</v-col>

									<v-col cols="12" sm="12" md="6">
										<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
											<div class="font-size-12 cl-grey font-weight-500">Total Dibayarkan</div>
											<h3 class="d-block text-left pt-2 info--text">{{ listSummaryBonus.totalPaid | toRupiah }}</h3>
										</v-card>
									</v-col>

									<v-col cols="12" sm="12" md="6">
										<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
											<div class="font-size-12 cl-grey font-weight-500">Total Saldo Komisi</div>
											<h3 class="d-block text-left pt-2 primary--text">{{ listSummaryBonus.totalSaldo | toRupiah }}</h3>
										</v-card>
									</v-col>
								</v-row>
							</v-col>
						</v-scroll-x-reverse-transition>

						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="6" md="6" class="flex-stretch">
								<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height chart-komisi">
									<div class="font-size-12 cl-grey font-weight-500">Summary Komisi</div>
									<div id="chart-summary-komisi">
										<apexchart type="bar" height="380" :options="summaryKomisi.chartOptions" :series="summaryKomisi.series"></apexchart>
									</div>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>
					</v-row>
				</div>

				<div class="mt-5">
					<v-row>
						<v-scroll-x-reverse-transition mode="in-out">
							<v-col cols="12" sm="6" md="6" v-if="Object.values(myProfile).length > 0">
								<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
									<v-row>
										<v-col cols="12">
											<div class="font-size-12 cl-grey font-weight-500 text-center">Total PV</div>
										</v-col>
									</v-row>
									<v-row class="mt-0">
										<v-col cols="12" class=" text-center">
											<div class="font-size-25 font-size-xs-18 cl-primary font-weight-600">{{ (parseInt(myProfile.network_total_downline_left) + parseInt(myProfile.network_total_downline_right)) | toNumber }}</div>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-scroll-x-reverse-transition>

						<v-scroll-x-transition mode="in-out">
							<v-col cols="12" sm="3" md="3" v-if="Object.values(myProfile).length > 0">
								<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
									<v-row>
										<v-col cols="12">
											<div class="font-size-12 cl-grey font-weight-500 text-center">PV Kiri</div>
										</v-col>
									</v-row>
									<v-row class="mt-0">
										<v-col cols="12" class=" text-center">
											<div class="font-size-20 font-size-xs-18 cl-secondary font-weight-600">{{ (parseInt(myProfile.network_total_downline_left)) | toNumber }}</div>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-scroll-x-transition>

						<v-scroll-x-transition mode="in-out">
							<v-col cols="12" sm="3" md="3" v-if="Object.values(myProfile).length > 0">
								<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height">
									<v-row>
										<v-col cols="12">
											<div class="font-size-12 cl-grey font-weight-500 text-center">PV Kanan</div>
										</v-col>
									</v-row>
									<v-row class="mt-0">
										<v-col cols="12" class=" text-center">
											<div class="font-size-20 font-size-xs-18 cl-secondary font-weight-600">{{ (parseInt(myProfile.network_total_downline_right)) | toNumber }}</div>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-scroll-x-transition>
					</v-row>	
				</div>
			</template>
		</template>

		<template v-else>
			<loaderdashboard :isActiveMember="isActiveMember" :networkType="networkType"></loaderdashboard>
		</template>
		<!-- end new dashboard -->

		<!-- growth network summary -->
		<template v-if="isActiveMember">
			<template v-if="!growthLoading">
				<div class="mt-5">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-row>
								<v-scroll-x-transition mode="in-out">
									<v-col cols="12" sm="5" md="6" v-if="Object.values(listSummaryBonus).length > 0">
										<v-card class="pa-4 elevation-0 rounded-lg h-100-pct hover-shadow chart-membergrowth">
											<v-row>
												<v-col cols="12">
													<div class="font-size-12 cl-grey font-weight-500">Pertumbuhan Mitra Minggu Ini</div>
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="12">
													<div id="chart-netgrow">
														<template v-if="growthSummary.length > 0">
															<apexchart type="area" height="350" :options="netGrow.chartOptions" :series="netGrow.series"></apexchart>
														</template>
														<template v-else>
															<div class="d-flex flex-column fill-height align-center justify-center pa-5">
																<v-icon color="grey" large>mdi-information-outline</v-icon>
																<div class="font-size-10 mt-4 text-center cl-grey">Belum ada data pertumbuhan mitra yang ditampilkan.</div>
															</div>
														</template>
													</div>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-scroll-x-transition>
								
								<v-scroll-x-reverse-transition mode="in-out">
									<v-col cols="12" sm="7" md="6">
										<v-card class="pa-4 elevation-0 rounded-lg h-100-pct hover-shadow">
											<v-row>
												<v-col cols="12">
													<div class="font-size-12 cl-grey font-weight-500">Data Mitra Terbaru</div>
												</v-col>
											</v-row>
											<template v-if="listDownline.length > 0">
												<v-row v-for="downline in fiveDownline" :key="downline.netgrow_node_id">
													<v-col cols="12" sm="12" md="4" class="d-flex align-center pb-0">
														<v-icon color="grey">mdi-account-circle-outline</v-icon>
														<div class="font-size-11 cl-grey text-capitalize ml-1"><div v-html="$options.filters.longText(downline.member_name, 17)"></div></div>
													</v-col>
													<v-col cols="6" sm="6" md="3" class="px-sm-0 pb-0 text-left text-md-right">
														<div class="font-size-11 cl-primary font-weight-500">{{ downline.network_code }}</div>
													</v-col>
													<v-col cols="6" sm="6" md="2" class="px-sm-0 pb-0 text-right text-md-center">
														<div class="font-size-11 cl-grey font-weight-500 text-capitalize">{{ downline.netgrow_node_position }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="3" class="pt-0 pb-0 pt-sm-3 text-left text-md-right">
														<div class="font-size-11 cl-grey">{{ downline.member_join_datetime | formatTgl('DD MMM YYYY') }}</div>
													</v-col>
												</v-row>
											</template>

											<template v-else>
												<div class="d-flex flex-column fill-height align-center justify-center pa-5">
													<v-icon color="grey" large>mdi-information-outline</v-icon>
													<div class="font-size-10 mt-4 text-center cl-grey">Belum ada data daftar downline yang ditampilkan.</div>
												</div>
											</template>
											<div class="pb-3"></div>
										</v-card>
									</v-col>
								</v-scroll-x-reverse-transition>
							</v-row>
						</v-col>
					</v-row>
				</div>
			</template>

			<template v-else>
				<loadernetwork :isActiveMember="isActiveMember" :networkType="networkType"></loadernetwork>
			</template>
		</template>
		<!-- growth network summary -->

	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import loaderDashboard from './components/loaderDashboard'
import loaderNetwork from './components/loaderNetwork'
import upgradeDateAlert from '@/components/upgradeDateAlert'

export default {
	components: {
		apexchart: VueApexCharts,
		loaderdashboard: loaderDashboard,
		loadernetwork: loaderNetwork,
		'upgradedate-alert': upgradeDateAlert
	},
	data() {
		function formatRupiah(bilangan) {
			if (bilangan && bilangan >= 1000) {
				var	reverse = bilangan.toString().split('').reverse().join(''),
				ribuan 	= reverse.match(/\d{1,3}/g);
				ribuan	= ribuan.join('.').split('').reverse().join('');
	
				return ribuan;
			} else {
				return Number(bilangan.toFixed(2))
			}
		}

		function formatKomisLabel(label) {
			var	text = label.replace('Komisi', 'K. ').replace('Repeat Order', 'RO')
			return text;
		}

		return {
			loading: false,
			growthLoading: false,
			fiveDownline: '',
			isActiveMember: false,
			networkType: null,
			kemitraan: [
				{
					type: 'pramitra',
					color: '#03bb5a',
					belanja: '0',
					badges: '',
					classText: 'mitra-pra'
				},
				{
					type: 'silver',
					color: '#688389',
					belanja: '1.300.000',
					badges: '/assets/icon/silver.svg',
					classText: 'mitra-silver'
				},
				{
					type: 'gold',
					color: '#6e490f',
					belanja: '3.900.000',
					badges: '/assets/icon/gold.svg',
					classText: 'mitra-gold'
				},
				{
					type: 'diamond',
					color: '#2a4fd6',
					belanja: '13.000.000',
					badges: '/assets/icon/diamond.svg',
					classText: 'mitra-diamond'
				}
			],

			summaryKomisi: {
				series: [{
					name: 'Komisi',
					data: []
				},{
					name: 'Saldo',
					data: []
				}, {
					name: 'Dibayarkan',
					data: []
				}],
				chartOptions: {
					chart: {
						type: 'bar',
						height: 500
					},
					plotOptions: {
						bar: {
							horizontal: true,
							dataLabels: {
								position: 'top',
							},
						}
					},
					dataLabels: {
						enabled: false,
						offsetX: -6,
						style: {
							fontSize: '9px',
							colors: ['#fff']
						},
						background: {
							padding: 6
						},
						formatter: function(value) {
							if(value != undefined) return formatRupiah(value);
						}
					},
					stroke: {
						show: true,
						colors: ['#fff']
					},
					tooltip: {
						shared: true,
						intersect: false,
						y: {
							formatter: function(value) {
								if(value != undefined) return 'Rp ' + formatRupiah(value);
							}
						},
					},
					xaxis: {
						categories: [],
						labels: {
							formatter: function(value) {
								if(value != undefined) return formatRupiah(value);
							}
						}
					},
				},
			},

			rincianKomisi: {
				series: [],
				chartOptions: {
					chart: {
						size: '120%'
					},
					colors: ['#feb019', '#ff4560', '#775dd0', '#24ae21', '#d2dc46', '#fb5d00'],
					labels: [],
					responsive: [{
						breakpoint: 480,
						options: {
							chart: {
								width: '100%',
								height: 350
							},
							legend: {
								position: 'bottom'
							}
						}
					}],
					legend: {
						position: 'bottom',
						fontSize: 9,
						formatter: function(seriesName, opts) {
							return [ '<span>' + formatKomisLabel(seriesName) + '</span>', '<span class="font-weight-bold">Rp ' + formatRupiah(opts.w.globals.series[opts.seriesIndex]) + '</span>']
						}
					},
					tooltip: {
						y: {
							formatter: function(value) {
								if(value != undefined) return 'Rp ' + formatRupiah(value);
							}
						}
					},
				},
			},

			netGrow: {
				series: [
					{
            name: 'Registrasi',
            data: []
          }, {
            name: 'Aktivasi',
            data: []
          }
				],

				chartOptions: {
					chart: {
						width: '100%',
						height: 350,
						type: 'area'
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						curve: 'smooth'
					},
					xaxis: {
						type: 'datetime',
						categories: []
					},
					tooltip: {
						x: {
							format: 'dd MMM yyyy'
						},
					},
				},
			}
		}
	},
	computed: {
		...mapState('profile', ['myProfile']),
		...mapState('bonus', ['listSummaryBonus', 'listBonusToday']),
		...mapState('network', ['listDownline']),
		...mapState('ewallet', ['ewalletSummary']),
		...mapState('dashboard', ['serialCount', 'growthSummary']),
	},
	methods: {
		...mapActions('profile', ['getProfile', 'getProfileMitra', 'getProfilePramitra']),
		...mapActions('bonus', ['getSummaryBonus', 'getDetailBonusToday']),
		...mapActions('network', ['getDownline']),
		...mapActions('ewallet', ['getEwalletSummary']),
		...mapActions('dashboard', ['getGrowthSummary', 'getSerialCount']),

		goActivation() {
			this.$router.push({name: 'aktivasi'})
		},

		goProfile() {
			this.$router.push({name: 'profile'})
		},

		sliceDownline() {
			let cloneDownline = [...this.listDownline]
			this.fiveDownline = cloneDownline.slice(0,10)
		},

		getNetworkType(type) {
			if(type === 'repeat_order') type = 'silver'
			this.networkType = this.kemitraan.find(x => x.type === type)
		},

		gotoUpgrade() {
			this.$router.push({name: 'upgrade-kemitraan'})
		},

		setDataRincianKomisi(data) {
			this.rincianKomisi.series = data.map((el) => el['acc'])
			this.rincianKomisi.chartOptions.labels = data.map((el) => el['label'])
			const labels = data.map((el) => el['label'])
			for (let i = 0; i < labels.length; i++) {
				this.summaryKomisi.chartOptions.xaxis.categories.push(labels[i].replace('Komisi', '').replace('Repeat Order', 'RO'))
			}
			this.summaryKomisi.series[0].data = data.map((el) => el['acc'])
			this.summaryKomisi.series[1].data = data.map((el) => el['saldo'])
			this.summaryKomisi.series[2].data = data.map((el) => el['paid'])
		},

		async setNetgrowSummaries(data) {
			this.netGrow.series[0].data = await data.map((el) => el['member_registration'])
			this.netGrow.series[1].data = await data.map((el) => el['member_activation'])
			this.netGrow.chartOptions.xaxis.categories = await data.map((el) => el['member_date'])
		},

		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},

		formatKomisiLabel(text) {
			if (text) {
				if (text === 'Komisi Sponsor Repeat Order') return 'Sponsor RO'
				else return text.replace('Komisi', '')
			} else {
				return '-'
			}
		}
	},
	async created() {
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)

		await this.$store.dispatch('setPageTitle', `Dashboard`)
		this.loading = await true
		await this.checkMemberActivation(data)

		if (this.isActiveMember) {
			await this.getProfileMitra()
			await this.getDetailBonusToday()
			await this.getSummaryBonus()
			await this.getNetworkType(this.myProfile.network_type)
			await this.setDataRincianKomisi(this.listSummaryBonus.arrKomisi)
			await this.getSerialCount()
			this.growthLoading = await true
			await this.getDownline().then(() => {
				this.sliceDownline()
			})
			await this.getGrowthSummary().then(() => {
				if (this.growthSummary) this.setNetgrowSummaries(this.growthSummary)
			})
		} else {
			await this.getProfilePramitra()
			await this.getNetworkType('pramitra')
		}
		await this.getEwalletSummary()

		this.loading = false

		setTimeout(() => {
			this.growthLoading = false
		}, 600);
	}
};
</script>

<style lang="scss">
	.serial-list {
		margin-top: 7px;
		li {
			line-height: 1.1;
		}
	}
</style>